/**
 * 配合 xtBase 不得不这样写
 * 与 xtbase Locale 一致：仅保留 en、zh-CN、ar、pt 四语
 */

import ar from "./lang/ar.json";
import cn from "./lang/cn.json";
import en from "./lang/en.json";
import pt from "./lang/pt.json";
// import es from "./lang/es.json";
// import hi from "./lang/hi.json";
// import hk from "./lang/hk.json";
// import id from "./lang/in.json";
// import ja from "./lang/ja.json";
// import ko from "./lang/ko.json";
// import ru from "./lang/ru.json";
// import th from "./lang/th.json";
// import tr from "./lang/tr.json";
// import vi from "./lang/vi.json";
export default { "zh-CN": cn, en, ar, pt };
